"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SnackBarContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "withSnackBar", {
  enumerable: true,
  get: function get() {
    return _withSnackBar["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Portal = _interopRequireDefault(require("../Portal"));

var _context = _interopRequireDefault(require("./context"));

var _SnackBar = _interopRequireDefault(require("./SnackBar"));

require("./styles.css");

var _constants = require("../../constants");

var _withSnackBar = _interopRequireDefault(require("./withSnackBar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SnackBarProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(SnackBarProvider, _Component);

  function SnackBarProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SnackBarProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SnackBarProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      list: [],
      refs: [],
      key: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      if (e.keyCode === _constants.KEY_ESCAPE) {
        _this.dismissLast();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "show", function (_ref) {
      var _ref$duration = _ref.duration,
          duration = _ref$duration === void 0 ? 15000 : _ref$duration,
          rest = _objectWithoutProperties(_ref, ["duration"]);

      var _this$state = _this.state,
          refs = _this$state.refs,
          list = _this$state.list,
          key = _this$state.key;

      var ref = _react["default"].createRef();

      refs.push(ref);
      list.push(_react["default"].createElement(_SnackBar["default"], _extends({
        key: key,
        id: key,
        onClear: _this.handleClear,
        ref: ref,
        duration: duration
      }, rest))); // update key value

      _this.setState(function (prevState) {
        return {
          key: prevState.key + 1,
          list: list,
          refs: refs
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showOnly", function (props) {
      _this.dismissAll();

      _this.show(props);
    });

    _defineProperty(_assertThisInitialized(_this), "showSuccess", function (_ref2) {
      var type = _ref2.type,
          rest = _objectWithoutProperties(_ref2, ["type"]);

      return _this.show(_objectSpread({
        type: 'success'
      }, rest));
    });

    _defineProperty(_assertThisInitialized(_this), "showError", function (_ref3) {
      var type = _ref3.type,
          rest = _objectWithoutProperties(_ref3, ["type"]);

      return _this.show(_objectSpread({
        type: 'error'
      }, rest));
    });

    _defineProperty(_assertThisInitialized(_this), "showWarning", function (_ref4) {
      var type = _ref4.type,
          rest = _objectWithoutProperties(_ref4, ["type"]);

      return _this.show(_objectSpread({
        type: 'warning'
      }, rest));
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [SnackBarProvider.className];
      (0, _lib.addClassByPropName)(names, _this.props);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (id) {
      // handle clearing with id
      var _this$state2 = _this.state,
          list = _this$state2.list,
          refs = _this$state2.refs;
      var listIndex = list.findIndex(function (snackBar) {
        return snackBar.props.id === id;
      });
      if (listIndex > -1) list.splice(listIndex, 1);
      var refIndex = refs.findIndex(function (snackBar) {
        return snackBar.current && snackBar.current.props.id === id;
      });
      if (refIndex > -1) refs.splice(refIndex, 1);

      _this.setState({
        list: list,
        refs: refs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dismissAll", function () {
      for (var _len2 = arguments.length, types = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        types[_key2] = arguments[_key2];
      }

      var refs = _this.state.refs;

      if ((0, _lib.arrayHasItems)(types)) {
        // filter refs to be dismiss
        var matchArr = refs.filter(function (_ref5) {
          var current = _ref5.current;
          return types.some(function (type) {
            return current && current.props.type === type;
          });
        });
        matchArr.forEach(function (_ref6) {
          var current = _ref6.current;
          return current && current.close();
        });
      } else {
        refs.forEach(function (_ref7) {
          var current = _ref7.current;
          return current && current.close();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dismissFirst", function () {
      var refs = _this.state.refs;

      if ((0, _lib.arrayHasItems)(refs)) {
        // min id = oldest snackbar
        var ids = refs.map(function (snackBar) {
          return snackBar.current.props.id;
        });
        var index = ids.findIndex(function (id) {
          return id === Math.min.apply(Math, _toConsumableArray(ids));
        });

        if (refs[index].current) {
          refs[index].current.close();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dismissLast", function () {
      var refs = _this.state.refs;

      if ((0, _lib.arrayHasItems)(refs)) {
        // max id = latest snackbar
        var ids = refs.map(function (snackBar) {
          return snackBar.current.props.id;
        });
        var index = ids.findIndex(function (id) {
          return id === Math.max.apply(Math, _toConsumableArray(ids));
        });

        if (refs[index].current) {
          refs[index].current.close();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dismissNth", function (n) {
      var refs = _this.state.refs;

      if ((0, _lib.arrayHasItems)(refs)) {
        var max = refs.length;
        var index = n - 1;
        if (index > max || index < 0) return;

        if (refs[index].current) {
          refs[index].current.close();
        }
      }
    });

    return _this;
  }

  _createClass(SnackBarProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var closeOnEsc = this.props.closeOnEsc;

      if (closeOnEsc) {
        window.addEventListener('keydown', this.handleCheckClose);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var closeOnEsc = this.props.closeOnEsc;

      if (closeOnEsc) {
        window.removeEventListener('keydown', this.handleCheckClose);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          children = _this$props.children,
          closeOnEsc = _this$props.closeOnEsc,
          rest = _objectWithoutProperties(_this$props, ["as", "children", "closeOnEsc"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var _this$state3 = this.state,
          list = _this$state3.list,
          refs = _this$state3.refs;
      var value = {
        list: list,
        refs: refs,
        show: this.show,
        showOnly: this.showOnly,
        showSuccess: this.showSuccess,
        showError: this.showError,
        showWarning: this.showWarning,
        dismissAll: this.dismissAll,
        dismissFirst: this.dismissFirst,
        dismissLast: this.dismissLast,
        dismissNth: this.dismissNth
      };
      return _react["default"].createElement(_context["default"].Provider, {
        value: value
      }, children, _react["default"].createElement(_Portal["default"], null, _react["default"].createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), list)));
    }
  }]);

  return SnackBarProvider;
}(_react.Component);

exports["default"] = SnackBarProvider;

_defineProperty(SnackBarProvider, "SnackBar", _SnackBar["default"]);

_defineProperty(SnackBarProvider, "Consumer", _context["default"].Consumer);

_defineProperty(SnackBarProvider, "className", 'MHub-SnackBar-List');

_defineProperty(SnackBarProvider, "displayName", 'SnackBar');

_defineProperty(SnackBarProvider, "propTypes", {
  as: _common.customPropTypes.as,
  closeOnEsc: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
});

_defineProperty(SnackBarProvider, "defaultProps", {
  as: null,
  closeOnEsc: true
});